(() => {
  'use strict';
  // Draft-only app-free gift sync. BOGO discounting remains Shopify's responsibility.
  // Adds the dedicated zero-priced gift variant; never changes paid products.
  const GIFT_VARIANT_ID = 45730061582512;
  const ROOT = () => (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let syncing = false;
  let queued = false;
  let timer = null;

  async function getCart() {
    const res = await fetch(ROOT() + 'cart.js', {
      credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store'
    });
    if (!res.ok) throw new Error('Could not read cart');
    return res.json();
  }

  async function refreshThemeCart(data) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && data && data.sections) {
      drawer.renderContents(data);
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: data }));
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    }
  }

  async function addGift() {
    const res = await fetch(ROOT() + 'cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    if (!res.ok) throw new Error('Gift add failed: ' + (await res.text()).slice(0, 120));
    await refreshThemeCart(await res.json());
  }

  async function removeGift(giftLine) {
    const res = await fetch(ROOT() + 'cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        id: giftLine.key, quantity: 0,
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    });
    if (!res.ok) throw new Error('Could not remove orphaned gift');
    await refreshThemeCart(await res.json());
  }

  async function syncGift() {
    if (syncing) { queued = true; return; }
    syncing = true;
    try {
      const cart = await getCart();
      const gifts = cart.items.filter(item => Number(item.variant_id) === GIFT_VARIANT_ID);
      const paidItems = cart.items.filter(item => Number(item.variant_id) !== GIFT_VARIANT_ID);
      if (paidItems.length && !gifts.length) {
        await addGift();
        console.info('[Nine Blush app-free gift] Added zero-priced Mini Glam Set.');
      } else if (!paidItems.length && gifts.length) {
        for (const gift of gifts) await removeGift(gift);
      } else if (gifts.length > 1) {
        for (const gift of gifts.slice(1)) await removeGift(gift);
      }
      const finalCart = await getCart();
      const finalGifts = finalCart.items.filter(item => Number(item.variant_id) === GIFT_VARIANT_ID);
      const finalPaid = finalCart.items.filter(item => Number(item.variant_id) !== GIFT_VARIANT_ID);
      window.NineBlushOfferCheck = {
        cartHasPaidItems: finalPaid.length > 0,
        freeGiftInCart: finalGifts.length > 0,
        freeGiftQuantity: finalGifts.reduce((sum, item) => sum + Number(item.quantity || 0), 0),
        freeGiftPriceIsZero: finalGifts.every(item => Number(item.final_price) === 0),
        checkedAt: new Date().toISOString()
      };
      document.dispatchEvent(new CustomEvent('nineblush:offer-check', { detail: window.NineBlushOfferCheck }));
    } catch (error) {
      console.warn('[Nine Blush app-free gift sync]', error);
    } finally {
      syncing = false;
      if (queued) { queued = false; setTimeout(syncGift, 500); }
    }
  }

  function scheduleSync(delay = 700) {
    clearTimeout(timer);
    timer = setTimeout(syncGift, delay);
  }

  document.addEventListener('DOMContentLoaded', () => scheduleSync(250));
  window.addEventListener('pageshow', () => scheduleSync(250));
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/cart/add"]')) scheduleSync(1200);
  }, true);
  document.addEventListener('click', event => {
    if (event.target.closest('cart-drawer .cart-item__quantity, cart-drawer cart-remove-button, cart-drawer .quantity__button, cart-drawer .drawer__close')) scheduleSync(900);
    if (event.target.closest('button[name="add"], [type="submit"][name="add"], product-form button[type="submit"]')) scheduleSync(1400);
  }, true);
  document.addEventListener('change', event => {
    if (event.target.closest('cart-drawer')) scheduleSync(900);
  });
  document.addEventListener('cart:updated', () => scheduleSync(500));
  document.addEventListener('cart:refresh', () => scheduleSync(500));
  document.addEventListener('shopify:section:load', () => scheduleSync(500));
})();